import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from '../../Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { ITemplates } from '../../models/ITemplates';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private http: HttpClient) { }

  getTemplatesbyCategory(categoryId: number, provider: string, showAll: boolean, locationId: number): Observable<ITemplates[]> {
    return this.http.get<ITemplates[]>(
      `${configuration.clinicapiUrl + 'Encounter/CategoryTemplates'}?categoryid=${categoryId}&&provider=${encodeURIComponent(provider).toString()}&&showAll=${showAll}&&LocationId=${sessionStorage.getItem("FacilityId")}`);
  }

  addnotesTemplate(template: ITemplates): any {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/MacroTemplates'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&LocationId=${sessionStorage.getItem("LocationId")}`, template, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  editnotesTemplate(template: ITemplates): any {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/UpdMacroTemplates'}`, template, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  deletenotesTemplate(templateId: number): any {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/DeleteTemplates'}?templatesid=${templateId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
